/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Vissza',
      changePassword: 'Jelszó megváltoztatása',
      copiedVaultId: 'Másolt!',
      copyVaultID: 'Másolja a Vault azonosítót',
      create: 'Létrehozás',
      next: 'Következő',
      notSure: 'Nem vagyok biztos benne',
      signUp: 'Regisztrálj',
      submit: 'Beadás',
      updatePassword: 'Jelszó frissítése',
    },
    Errors: {
      createReportFailed: 'Jelentés létrehozása sikertelen.',
    },
    ReportStatus: {
      CLOSED: 'Bezárva',
      INVESTIGATING: 'Vizsgálat',
      NEW: 'Beadva',
      READ: 'Olvasás',
    },
    general: {
      navbar: {
        caseSettings: 'Esetbeállítások',
        changePassword: 'Jelszó megváltoztatása',
        logOut: 'Kijelentkezés',
        notifications: 'Értesítések',
        notificationsDrawer: {
          appFileScanFailed: 'Egy fájl megbukott a biztonsági ellenőrzésen',
          appReportMatch: 'Az Ön GoTogether rekordja egyezést talált',
          appReportReassigned: 'Új ügyintézőt rendeltek hozzá',
          case: 'Eset',
          caseAssigned: 'Önnek szóló ügy',
          caseImporterJobCompleted: {
            PartialSuccess: 'Az ön esetimportálása hibákkal zárult',
            failure: 'Az ön ügyimportja sikertelen volt',
            success: 'Az Ön esetének importálása sikeresen befejeződött.',
          },
          caseLinked: 'Eset összekapcsolva',
          caseTeamInvite: 'Hozzáadva az ügyhöz',
          caseUnlinked: 'Eset szétcsatolva',
          dataSanitisation: 'Jelentés részleteinek frissítése',
          emptyDescription: 'Ellenőrizze később az új értesítésekért',
          emptyTitle: 'Minden naprakész',
          importId: 'Importálási azonosító:',
          learnMore: 'Tudj meg többet',
          markAllAsRead: 'Jelölj mindent olvasottnak',
          newMessage: 'Új üzenet',
          newReport: 'Új jelentés érkezett',
          permissionRemoved: 'Eltávolítva az ügytől',
          postSSubmissionFile: 'Hozzáadott bizonyítéki fájl(ok)',
          report: 'Jelentés',
          reportAssigned: 'Önnek kijelölt jelentés',
          reportStatusChange: 'Jelentés állapota megváltozott',
          reporterAnonymised: 'Az adataidat anonimizálták',
          reporterReportSubmitted: {
            subtitle:
              'Azt javasoljuk, hogy készítsen egy másolatot a jelentéséről',
            title: 'Beadott jelentés',
          },
          mitigationPlanReminder:
            'A kockázatcsökkentési terv jóváhagyása szükséges',
          staleCase: 'Lezáratlan ügy',
        },
        privacyStatement: 'Adatvédelmi nyilatkozat',
        reporter: {
          myReports: 'Az én jelentéseim',
        },
        settings: 'Beállítások',
        technicalSupport: 'Technikai támogatás',
        title: 'Fiók',
      },
      time: {
        day: 'Nap',
        days: 'Napok',
        hour: 'Óra',
        hours: 'Órák',
        minute: 'Perc',
        minutes: 'Percenként',
        second: 'Második',
        seconds: 'Másodpercek',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonim',
        autoTranslate:
          'Az automatikus fordítás alapértelmezés szerint ki van kapcsolva.',
        backToMessages: 'Vissza az üzenetekhez',
        caseSettings: 'Eset beállítások.',
        changeInProfile:
          'Ha meg szeretnéd változtatni ezt a beállítást, megteheted a profilodban',
        deletedByMessage: 'Törölte: {{author}}',
        deletedMessageLabel: 'Ezt az üzenetet törölték',
        description:
          'Amikor az automatikus fordítás be van kapcsolva, minden jelentési üzenetet\n          automatikusan lefordít a mesterséges intelligencia az ön böngészőjében\n          kiválasztott alapértelmezett nyelvre.',
        descriptionSecondHalf:
          'Az összes üzenet eredeti változatát mindig megőrizzük, és azokat a csevegésben megtalálhatja.',
        messagePlaceholder: 'Kezdjen el gépelni...',
        messageSettings: 'Üzenetbeállítások.',
        originalMessages: 'Eredeti',
        showMoreBanner: 'Tudjon meg többet az automatikus fordításokról',
        titlev2: 'Olvassa el az összes üzenetet a preferált nyelvén.',
        translatedMessageLabel: 'Fordított üzenet',
        translatedMessages: 'Fordítva',
        understood: 'Értettem',
      },
      Country: {
        description: 'Melyik országban dolgozik?',
        header: 'Melyik országban dolgozik?',
        noOptions: 'Nem találhatók országok',
        other: 'Egyéb',
        placeholder: 'Keresés ország szerint...',
      },
      CreatePublicReport: {
        createReport: 'Új jelentés létrehozása',
        helpPage: 'Menj a segítség oldalunkra',
        loginToOpr: 'Jelentkezzen be a jelentések nyomon követéséhez',
        or: 'vagy',
        passwordPlaceholder: 'Adja meg jelszavát',
        phoneNumberLoginFailed:
          'Bejelentkezés sikertelen, a telefonszám / pin kód helytelen',
        phoneNumberPlaceholder: 'Adja meg a telefonszámát',
        phoneNumberTooltip:
          'Adja meg azt a telefonszámot, amellyel kapcsolatba lépett a VaultTalk.',
        pinPlaceholder: 'Adja meg a PIN-kódot',
        reportIntroductionParagraph1:
          'Amikor egy eseményt jelent, néhány kérdést fogunk feltenni, hogy támogassuk Önt tapasztalata dokumentálásában.',
        reportIntroductionParagraph2:
          'Mielőtt elküldi, van lehetősége névtelen maradni a személyes adatok védelme érdekében.',
        reportIntroductionParagraph3:
          'Beküldés után bármikor bejelentkezhet, hogy megtekintse jelentése előrehaladását és beszélgethessen az ügyintézővel.',
        reportIssue: 'Probléma jelentése',
        usernameLoginFailed:
          'Bejelentkezés sikertelen, felhasználónév/jelszó hibás',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'A kapcsolat a vállalathoz szükséges',
            reportedCategoryRequired: 'Jelentett kategória szükséges',
          },
        },
        vaultId: 'Vault azonosító',
        vaultIdPlaceholder: 'Adja meg az email címét vagy a Vault ID-jét',
        vaultIdTooltip:
          'Az anonim jelentésekhez a Vault ID alfanumerikus. Ha a jelentés nem volt anonim, akkor a Vault ID az ön email címe.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'A jelszavad',
        yourPhoneNumber: 'Az Ön telefonszáma',
        yourPin: 'Az Ön 6 számjegyű PIN kódja',
        yourVaultId: 'Az Ön Vault ID-je',
      },
      CustomHeader: {
        companyLogo: 'Vállalati logó',
        openReporting: 'Jelentés megnyitása',
        userSettings: 'Felhasználói beállítások',
      },
      Date: {
        approximateDescription:
          'Emlékszik a körülbelüli dátumra, amikor az esemény megtörtént?',
        approximatePlaceholder:
          'Például: 6 hónappal ezelőtt / tavaly / múlt novemberben',
        cancel: 'visszavonás',
        clear: 'törlés',
        description: 'Emlékszik a dátumra, amikor az esemény megtörtént?',
        header: 'Melyik napon történt?',
        ok: 'ok',
        placeholder: 'Például: 2020. június 21.',
      },
      Description: {
        whatHappened: 'Mi történt?',
        whatHappenedPlaceholder: 'Fejtse ki saját szavaival...',
        whatHappenedText: 'Fejtse ki saját szavaival, hogy mi történt',
      },
      Details: {
        disclaimer:
          'Ezeket a részleteket a jelentésével együtt tesszük közzé. Ha névtelenül szeretne maradni, győződjön meg róla, hogy nem tartalmaznak azonosító információt.',
        emailPlaceholder: 'E-mail cím (opcionális)',
        fullNamePlaceholder: 'Teljes név (opcionális)',
        header: 'Az Ön adatai',
        nonAnonSubtitle:
          'Kérjük, adjon meg vagy egy nevet, vagy egy e-mail címet. Ha értesítéseket szeretne kapni erről a jelentésről, adja meg a megfelelő e-mail címet alább.',
        nonOptionalEmailPlaceholder: 'E-mail',
        nonOptionalFullNamePlaceholder: 'Teljes név',
        subtitle:
          'Ha értesítéseket szeretne kapni erről a jelentésről, adja meg a megfelelő e-mail címet az alábbiakban.',
      },
      Emotion: {
        description: 'Hogyan érezte magát ettől? Milyen hatással járt?',
        header: 'Milyen hatással járt?',
        placeholder: 'Kezdjen el gépelni...',
      },
      Evidence: {
        addedHeading: 'Hozzáadva',
        deletedMessage: 'törölve lett',
        deletedStatus: 'Törölve',
        failedToOpenFileMessage:
          'A fájl megnyitása sikertelen. Kérjük, próbálja újra.',
        fileStatuses: {
          infectedUpload: 'Biztonsági ellenőrzés által jelzett',
          passedUpload: 'Átment a biztonsági ellenőrzésen',
          pendingUpload: 'Biztonsági ellenőrzés folyamatban',
          readyForDownload: 'Letölthető',
        },
        mobileErrorMessage: 'Jelölt fájlok: üzenetet küldj a ügykezelődnek',
        nameHeading: 'Név',
        statusHeading: 'Állapot',
        tableTitle: 'Bizonyíték',
        webErrorMessage:
          'Megjelölt fájlok: Ha a fájljai megjelölésre kerültek, kérjük, üzenjen a ügykezelőnek',
      },
      FileUpload: {
        addFiles: 'Fájlok hozzáadása',
        addMoreFiles: 'Tölts fel több fájlt',
        confirm: 'Megerősítés',
        description:
          'Fájlok hozzáadása bizonyítékként segítheti az ügyintézője által végzett hatékony problémamegoldást. Kérjük, vegye figyelembe a fájl tartalmát (beleértve a fájl metadata adatait) ha anonim maradni szeretne, és tartsa tiszteletben mások jogait és az alkalmazandó törvényeket.',
        dragDrop: 'Húzza ide a fájlokat vagy',
        errorMessage:
          'A(z) fájl(ok) hálózati hiba miatt nem sikerült. Kattintson alább, hogy üzenetet küldjön az ügykezelőjének segítségért.',
        fileLimit: 'Minden fájlméret korlát: 100MB',
        fileUploadLimitText: 'Csak 10 fájlt tölthet fel.',
        header: 'Adj bizonyítékot',
        helpArticle: 'segítség cikk',
        highlighted: 'fájlok böngészése',
        information: 'Támogatott fájltípusok',
        moreInformation:
          'További információkért, kérjük, tekintse meg ezt <a>segítség cikk</a>',
        postSubmissionErrorMessage:
          "A rendszerhiba miatt nem tudtuk feltölteni az Ön fájljait. Kérjük, válassza újra a 'megerősítés' opciót.",
        tooltipAudio: 'Audió:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumentumok:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Képek:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Szöveg:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Videó:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'A fájl túl nagy',
          invalidFileType: 'Nem támogatott fájltípus: {{extension}}',
          systemError: 'Rendszerhiba',
          tooManyFiles: 'A fájlok maximális száma {{maxFiles}}',
        },
        uploadFiles: 'Fájlok feltöltése',
      },
      Loading: {
        loading:
          'Kérjük, várjon, amíg benyújtjuk jelentését az ügykezelőnek...',
        postSubmissionLoading: 'Kérjük, várjon, amíg elküldjük a fájljai(t)...',
      },
      Location: {
        description: 'Hol történt az eset?',
        header: 'Hol történt az eset?',
        placeholder: 'Például: az irodában',
      },
      MessageListBox: {
        messageCaseManager: 'Üzenetkezelő',
        report: 'Jelentés {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Fordítás letiltva',
        enableTranslationLabelEnabled: 'Fordítás engedélyezve',
        enableTranslationsDescription:
          'Tegye lehetővé az automatikus fordításokat, és olvassa el az összes jelentés üzenetet a preferált nyelven. A lefordított nyelv az ön által választott nyelvre alapul.',
        enableTranslationsHeader:
          'Engedélyezze az automatikus fordításokat a jelentési üzenetekhez',
        enableTranslationsSubDescriptionv2:
          'Az egyes csevegésekben váltogathat a fordított és az eredeti nyelv között.',
        updateTranslationFailed: 'Frissítési fordítás sikertelen',
        updateTranslationSuccess:
          'A fordítási beállítások sikeresen frissültek',
      },
      Password: {
        changePasswordHeader: 'Jelszó megváltoztatása',
        createNewPassword: 'Kérjük, hozzon létre egy új jelszót',
        createPasswordHeader: 'Az Ön jelszava',
        currentPasswordPlaceholder: 'Adja meg jelenlegi jelszavát',
        description:
          'Az érvényes jelszónak legalább 9 karakter hosszúságúnak kell lennie, és tartalmaznia kell egy nagybetűt és egy számot',
        enterCurrentPassword: 'Kérjük, adja meg jelenlegi jelszavát',
        forgottenPasswordInstructions:
          'Adja meg alfanumerikus Vault azonosítóját (nem az e-mail címét) és az e-mail címét a jelszó visszaállításához.',
        newDescription:
          'Hozzon létre erős jelszót a fiókjának biztonságának megőrzése érdekében. Kezdjen el gépelni, hogy lássa az alábbi irányelveket.',
        passwordPlaceholder: 'Jelszó létrehozása',
        passwordResetRequestedDescription:
          'Ha a Vault ID-d rendelkezésre áll a rendszerünkben, akkor kapni fogsz egy e-mailt a jelszavad visszaállításának lépéseivel.',
        passwordResetRequestedHeader: 'Jelszó visszaállító linket kértünk',
        reenterPlaceholder: 'Adja meg ismét a jelszót',
        subtitle:
          'Hozzon létre egy jelszót a jelentés benyújtásához, és hogy a jövőben hozzáférjen',
        yourVaultId: 'Az Ön Vault ID-je',
        yourVaultIdPlaceholder: 'Adja meg a Vault ID-jét (pl. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Egy adott személyt vagy több személyt jelent? Meg tudná nevezni őket vagy tudna róluk személyleírást adni?',
        header: 'Érintett személyek',
        placeholder:
          'Kezdjen el gépelni, és vesszővel adjon hozzá több nevet vagy leírást',
      },
      PoweredByVault: '{{company}} által',
      PrivacyStatement: 'Termék Adatvédelmi Nyilatkozat',
      PublicMessageList: {
        myMessages: 'Üzeneteim',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Hozzáadott bizonyíték a meglévő jelentéshez',
        backToReportId: 'Vissza a jelentés azonosítóhoz: {{reportId}}',
        description:
          'Fájlok hozzáadása bizonyítékként segíthet a hatékonyság növelésében a ügykezelője által történő problémamegoldás során. Kérjük, vegye figyelembe a fájl tartalmát (beleértve a fájl metaadatait) ha szeretne névtelen maradni, és tartsa tiszteletben mások jogait és az alkalmazandó törvényeket. További információért, kérjük, olvassa el ezt <a>segítség cikk</a>',
        header: 'Adjon hozzá további bizonyítékot a jelentéshez',
        vaultTalkOpenCaseHeader: 'Adj hozzá bizonyítékot a jelentésedhez',
      },
      PublicReport: {
        anonymous: 'Anonim',
        backToReports: 'Vissza a jelentésekhez',
        skipped: 'Kihagyva',
      },
      PublicReportCard: {
        addEvidence: 'Adj hozzá további bizonyítékot',
        messageCaseManager: 'Üzenetkezelő',
        reportId: 'Jelentési azonosító:',
        submitted: 'Beadva',
        vaultTalkClosedCaseCTA: 'Tekintse meg a bizonyítékot',
        vaultTalkOpenCaseCTA: 'Adj hozzá bizonyítékot',
        viewAdditionalEvidence: 'Tekintse meg a további bizonyítékokat',
        viewReport: 'Jelentés megtekintése',
      },
      PublicReportsList: {
        reportingSystem: 'Jelentési rendszer',
      },
      Question: {
        placeholder: 'Kezdjen el gépelni...',
        question: 'Adjon meg részleteket',
        questionText:
          'Kérjük, ossza meg velünk aggodalmát, frissítését vagy kérdését.',
      },
      Relationship: {
        header: 'Kapcsolata a szervezettel',
        tellUsAbout: 'Kérjük, meséljen a szervezettel fennálló kapcsolatáról',
      },
      ResponsiveNavMenu: {
        messages: 'Az üzeneteim',
        reports: 'Az én jelentéseim',
      },
      Site: {
        description: 'Melyik telephelyen dolgozik?',
        header: 'Melyik telephelyen dolgozik?',
        noOptions: 'Nem található telephely',
        other: 'Egyéb',
        placeholder: 'Telephely keresése...',
      },
      SpamPuzzle: {
        dialog: 'A folytatáshoz kérjük, rakja ki ezt a kirakót',
      },
      SubmissionTypes: {
        reportIssue: 'Válasszon kategóriát',
        whatType:
          'Válassza ki azt a kategóriát, amely legjobban leírja jelentését',
      },
      SubmitSuccess: {
        category: '<bold>Kategória:</bold> {{category}}',
        country: '<bold>Ország:</bold> {{country}}',
        dateSubmitted: '<bold>Beküldés dátuma:</bold> {{date}}',
        recordYourVaultID: 'Jegyezze meg ezt az információt a bejelentkezéshez',
        successInformation: 'További információ',
        successMessage:
          'A jelentését benyújtották, és készen áll az áttekintésre. A csatolt fájlok, amelyek figyelmet igényelnek, bejelentkezéskor megjelölésre kerülnek. Lépjen be alább a jelentés frissítéseinek megtekintéséhez és üzenet küldéséhez az ügyintézőjének.',
        successSanitationMessage:
          'Mentsen egy másolatot a saját nyilvántartásod számára, és tartsd biztonságban a Vault-ID-dat — szükséged lesz rá, hogy hozzáférj a frissítésekhez és üzenetet küldj az ügyintéződnek.',
        successSanitationTagline:
          'A jelentésed be lett nyújtva és biztonságosan tárolva.',
        successThankYou: 'Köszönöm a jelentésed!',
        viewReport: 'Jelentés megtekintése',
      },
      Time: {
        approximateDescription:
          'Emlékszik a körülbelüli időpontra, amikor az esemény megtörtént?',
        approximatePlaceholder: 'Például: reggel, délután',
        description: 'Emlékszik az időpontra, amikor az esemény megtörtént?',
        header: 'Mikor történt az eset?',
        invalidTime: 'Az időnek ÓÓ:PP formátumban kell lennie',
      },
      UserSettingsDialog: {
        changePassword: 'Jelszó megváltoztatása',
        closeDialog: 'Párbeszéd bezárása',
        logout: 'Kijelentkezés',
        messageSettings: 'Üzenetbeállítások',
        userSettings: 'Felhasználói beállítások',
      },
      Witnesses: {
        description: 'Elmondta valakinek, vagy látta valaki, hogy mi történt?',
        header: 'Voltak szemtanúk?',
        placeholder: 'Kezdjen el gépelni...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Üzenet küldése',
        title: 'Ügyintéző üzenet',
        translationHeader: 'Tudjon meg többet az automatikus fordításokról',
      },
      ReportCard: {
        addEvidence: 'Adjon hozzá bizonyítékot',
        submissionModeVia: 'via {{beküldési mód}}',
        viewEvidence: 'Tekintse meg a bizonyítékot',
      },
      ReportList: {
        yourReports: 'A jelentéseid',
      },
      ReportingActivate: {
        buttonText: 'Folytatás',
        description:
          'Ha szervezete regisztrált Önnek egy fiókot, küldünk Önnek egy e-mailt a beállítás befejezéséhez szükséges utasításokkal.',
        emailInput: 'E-mail',
        header: 'Adja meg a munkahelyi e-mail címét',
        successAccount:
          'Ha szervezete regisztrált Önnek egy fiókot, akkor emailben elküldjük az beállítás befejezéséhez szükséges utasításokat.',
        successEmail:
          'Ha nem látja rögtön, kérjük várjon néhány percet és frissítse az e-mail beérkezőjét.',
        successHeading: 'Köszönöm',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Adj bizonyítékot a jelentésedhez',
        descriptionText:
          'Fájlok hozzáadása bizonyítékként segíthet a ügykezelője hatékonyabb problémamegoldásban. Kérjük, vegye figyelembe a fájl tartalmát (beleértve a fájl metaadatokat) ha szeretne névtelen maradni, és tartsa tiszteletben más emberek jogait és az alkalmazandó törvényeket. További információért kérjük olvassa el ezt a <a>segítő cikket</a>',
        emptyMessage: 'Nincs további feltöltött bizonyíték',
      },
      ReportingChangePassword: {
        back: 'Vissza',
        description:
          'Hozzon létre egy erős jelszót, hogy fiókját biztonságban tartsa. Kezdjen el írni, hogy lássa az alábbi útmutatókat.',
        errorToast: 'Nem lehet jelszót létrehozni, érvénytelen token.',
        header: 'Jelszó megváltoztatása',
        incorrectCurrentPassword:
          'A jelenlegi jelszó hibás. Kérjük, ellenőrizze és próbálja újra.',
        invalidToken: 'Érvénytelen token',
        passwordUpdated: 'Jelszó frissítve',
        passwordUpdatedDescription:
          'A jelszava sikeresen frissítve. Köszönjük, hogy megtette ezt a lépést az adatai biztonságának megőrzése érdekében!',
        passwordUsedBefore: 'Jelszó újrafelhasználása nem engedélyezett',
        passwordUsedBeforeDescription:
          'A biztonságod érdekében nem használhatod újra az utolsó hat jelszavadat. Kérjük, válassz egy új, egyedi jelszót, hogy biztonságban tartsd a fiókodat, és próbáld meg újra.',
        toastDescription:
          'A jelszava sikeresen frissült. Köszönjük, hogy megtette ezt a lépést adatai biztonságának megőrzése érdekében!',
        toastMessage: 'Jelszó frissítve',
        updatePasswordCTA: 'Jelszó frissítése',
      },
      ReportingConnect: {
        cancelButton: 'Mégse',
        connectButton: 'Csatlakozás',
        disclaimer:
          'A Slack fiókodat összekapcsolva a Vault fiókoddal biztosíthatod a biztonságos és privát kapcsolatot.<br /><br />Az összekapcsolás után közvetlenül a Slackból jelenthetsz szabálytalanságot vagy tehet fel kérdést. Mindig lehetőséged lesz névtelenül jelentést tenni az összekapcsolás után. Az adatvédelem és a biztonság a legfőbb prioritásaink.',
        heading:
          'A Vault Platform engedélyt kér, hogy hozzáférjen a(z) {{organisationName}} Slack fiókodhoz.',
        listHeading: 'Mit fog tudni Vault?',
        permissionIdentity: {
          extraInfo:
            'Vault képes lesz megtekinteni a Slack felhasználóid személyazonosságát',
          heading:
            'Tekintse meg egy felhasználó személyazonosságával kapcsolatos információkat',
        },
        permissionNotifications: {
          extraInfo:
            'Vault képes lesz értesítéseket küldeni a Slack fiókjába, bármilyen beküldött jelentés vagy kérdés frissítéseivel kapcsolatban.',
          heading: 'Értesítéseket küldeni',
        },
        permissionOverview: {
          extraInfo:
            'Vault áttekintést fog megjeleníteni az összes beküldött anyagról a kezdőlapon',
          heading: 'Beküldések áttekintése',
        },
        permissionSubmitReport: {
          extraInfo:
            'Ez lehetővé teszi Vault számára, hogy jelentést küldjön vagy kérdést tegyen fel közvetlenül a szervezetének a Slackből.',
          heading: 'Nyújtson be jelentést vagy kérdést az Ön nevében',
        },
        successfulConnectionDescription:
          'A Vault fiókod és a Slack fiókod most már összekapcsolva. Most már bezárhatod ezt a fület és visszatérhetsz a Slack-re.',
        successfulConnectionHeading: 'Sikeresen csatlakozott',
        unsuccessfulConnectionDescription:
          'Valami hiba történt. Kérjük, zárja be ezt a fület és térjen vissza a Slack-be, majd próbálja meg újra.',
        unsuccessfulConnectionHeading: 'Csatlakozás sikertelen',
      },
      ReportingForgotPassword: {
        description:
          'Adja meg azt az e-mail címet, amelyik a fiókjához tartozik, és mi elküldjük Önnek a jelszó visszaállításához szükséges linket.',
        heading: 'Elfelejtett jelszó',
        invalidTokenError: 'Nem sikerül jelszót létrehozni, érvénytelen token.',
        passwordReuseError: 'Jelszó újbóli felhasználása nem engedélyezett',
        passwordReuseErrorDescription:
          'Az ön biztonsága érdekében nem használhatja újra az utolsó hat jelszavát. Kérjük, válasszon egy új, egyedi jelszót fiókjának biztonsága érdekében, és próbálja újra.',
        sendLink: 'Küldj újraindító linket',
        sendLinkFailure: 'Valami hiba történt',
        sendLinkFailureDescription:
          'Menjen vissza a <a>Reporter Hub</a>-hoz és próbálja újra. Ha a probléma továbbra is fennáll, lépjen velünk kapcsolatba a <mailto>techsupport@vaultplatform.com</mailto> címen.',
        sendLinkSuccess: 'Jelszó visszaállítási link elküldve',
        sendLinkSuccessDescription:
          'Elküldtük a jelszó visszaállításához szükséges linket a következő email címre: {{email}}',
        updatePasswordSuccess: 'Jelszó frissítve',
        updatePasswordSuccessDescription:
          'A jelszava sikeresen frissítve lett. Köszönjük, hogy ezt a lépést megteszi adatai biztonságának megőrzése érdekében!',
      },
      ReportingLogin: {
        accountFrozen: 'A fiók fagyasztva van',
        accountLocked:
          'Túl sokszor próbáltak bejelentkezni helytelenül. A fiók zárolva van legfeljebb 1 órára. Jelszó visszaállítása ebben az időben nem lehetséges.',
        accountLockedPermanently:
          'Fiókját zárolták. Használja a jelszó visszaállítást, hogy újra hozzáférjen, vagy vegye fel a kapcsolatot a rendszergazdával további segítségért.',
        createAccountCTA: 'Regisztráljon egy fiókhoz',
        currentPassword: 'Jelenlegi jelszó',
        emailLabel: 'Az Ön Emailje',
        forgotPassword: 'Elfelejtette a jelszavát?',
        loginButton: 'Bejelentkezés',
        newPasswordPlaceholder: 'Új jelszó',
        passwordFailMessage:
          'Menjen vissza a Vault alkalmazáshoz a Slack-en és próbálja újra. Ha a probléma továbbra is fennáll, forduljon hozzánk a techsupport@vaultplatform.com címen.',
        passwordFailTitle: 'Valami hiba történt',
        passwordLabel: 'Az Ön jelszava',
        passwordPlaceholder: 'Adja meg a jelszavát',
        passwordResetRequired: 'Jelszó visszaállítása szükséges',
        passwordSuccessfullySetMessage:
          'Menjen vissza a Vault alkalmazáshoz a Slackben és hitelesítse az új jelszavával, hogy folytathassa, ahol abbahagyta.',
        passwordSuccessfullySetTitle: 'Jelszó sikeresen beállítva',
        reenterPlaceholder: 'Írd be újra a jelszót',
        title: 'Riporter Hub',
        tooltip:
          'Ha még soha nem állított be jelszót a Vault alkalmazáshoz, kövesse a következő utasításokat az elinduláshoz. Ha elfelejtette a jelszavát, használja az alábbi "Elfelejtett jelszó" linket.',
        usernameLoginFailed:
          'Bejelentkezés sikertelen, a felhasználónév vagy a jelszó hibás.',
      },
      ReportingReset: {
        failureDescription:
          'Menjen vissza a Vault alkalmazáshoz a Slackben és próbálja újra. Ha a probléma továbbra is fennáll, lépjen velünk kapcsolatba a következő címen: <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Valami hiba történt',
        successDescription:
          'Menjen vissza a Vault alkalmazáshoz a Slackben, és hitelesítse az új jelszavával, hogy folytathassa, ahol abbahagyta',
        successHeading: 'Jelszó sikeresen beállítva',
      },
      noReports: {
        description:
          'Az összes beküldött jelentés itt jelenik meg. Tudjon meg többet arról, hogy milyen módon nyújthat be jelentést Vaultban.',
        descriptionHelpArticle: 'ez a segítő cikk',
        errorDescription:
          'Problémába ütköztünk a jelentéseid betöltése során. Kérjük, próbáld meg frissíteni az oldalt.',
        errorDescriptionSecondary:
          'Ha ez nem működik, kérjük, lépjen kapcsolatba velünk a',
        errorTitle: '⚠️ Hoppá, valami hiba történt',
        title: 'Még nincsenek jelentései',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Engedélyezze az automatikus fordításokat és olvassa el az összes jelentés üzenetet a preferált nyelvén. A lefordított nyelv a készülékén kiválasztott nyelven alapul.',
          autoTranslationDescription2:
            'Váltani tud az eredeti és a fordított nyelv között minden csevegésben.',
          autoTranslationTitle:
            'Aktiválja az automatikus fordításokat a jelentési üzenetekhez',
          header: 'Üzenetbeállítások',
          subHeader: 'Konfigurálja, hogyan jelenjenek meg az üzenetek',
        },
        notificationSettings: {
          emailDescription:
            'Kapjon email értesítéseket a jelentéseire vonatkozó fontos frissítésekkel kapcsolatban',
          emailTitle: 'Email értesítések',
          header: 'Értesítési beállítások',
          subHeader: 'Állítsa be, hogyan kapja meg az értesítéseket',
        },
        title: 'Beállítások',
        updatedSettingsFailure: 'Beállításainak frissítése sikertelen',
        updatedSettingsSuccess: 'Sikeresen frissítette beállításait',
      },
    },
    validators: {
      passwordLength:
        'A jelszónak legalább 9 karakter hosszúságúnak kell lennie',
      passwordLowercase: 'A jelszónak legalább 1 kisbetűt kell tartalmaznia',
      passwordMissMatch: 'A jelszónak és a megerősítő mezőnek egyeznie kell.',
      passwordNumeric: 'A jelszónak legalább 1 számot kell tartalmaznia',
      passwordUppercase: 'A jelszónak legalább 1 nagybetűt kell tartalmaznia',
    },
    validatorsNew: {
      passwordLength: '10 és 30 karakter között',
      passwordLowercase: 'Legalább egy kisbetű',
      passwordMissMatch: 'A jelszavak nem egyeznek meg',
      passwordNumeric: 'Legalább egy szám',
      passwordSpecialCharacter: 'Legalább egy speciális karakter',
      passwordUppercase: 'Legalább egy nagybetű',
    },
  },
};

export default translations;
